import { MemberStatus } from '@/modules/team/types/team-member';

import { MemberStatusDTO } from '../types/dto/member-status.dto';

/**
 * Maps MemberStatusDTO from API to MemberStatus domain model
 */
export const mapMemberStatusFromDTO = (dto: MemberStatusDTO): MemberStatus => {
  switch (dto) {
    case MemberStatusDTO.ACTIVE:
      return MemberStatus.Active;
    case MemberStatusDTO.INVITED:
      return MemberStatus.Invited;
    case MemberStatusDTO.INVITE_EXPIRED:
      return MemberStatus.Expired;
    case MemberStatusDTO.BASIC:
      return MemberStatus.Basic;
    case MemberStatusDTO.ARCHIVED:
      return MemberStatus.Archived;
    case MemberStatusDTO.PLACEHOLDER:
      return MemberStatus.Placeholder;
    default:
      return MemberStatus.Active;
  }
};

/**
 * Maps MemberStatus domain model to MemberStatusDTO for API
 */
export const mapMemberStatusToDTO = (status: MemberStatus): MemberStatusDTO => {
  switch (status) {
    case MemberStatus.Active:
      return MemberStatusDTO.ACTIVE;
    case MemberStatus.Invited:
      return MemberStatusDTO.INVITED;
    case MemberStatus.Expired:
      return MemberStatusDTO.INVITE_EXPIRED;
    case MemberStatus.Basic:
      return MemberStatusDTO.BASIC;
    case MemberStatus.Archived:
      return MemberStatusDTO.ARCHIVED;
    case MemberStatus.Placeholder:
      return MemberStatusDTO.PLACEHOLDER;
    default:
      return MemberStatusDTO.ACTIVE;
  }
};
